/* global __twigVars__, __DEV__ */

// This is here to ensure that jQuery is available outside of webpack.
if (__DEV__ && typeof global.jQuery === "undefined") {
    global.$ = global.jQuery = jQuery;
}

function getByPath(needle, values, defValue) {
    let haystack;

    if (Array.isArray(values)) {
        haystack = Array.from(values);
    } else if (typeof values === "object") {
        haystack = Object.assign({}, values);
    } else {
        // Non-array/-object
        return values;
    }

    for (const part of needle.split(".")) {
        if (typeof haystack[part] !== "undefined" && haystack[part] !== null) {
            haystack = haystack[part];
            continue;
        }

        // Early return at the first key part that does not exist.
        return defValue;
    }

    return haystack;
}

function isJSON(str) {
    if (typeof str !== "string") {
        return false;
    }

    if (str === "null") {
        return true;
    }

    const length = str.length - 1;
    return (str.indexOf("\"", 0) === 0 && str.indexOf("\"", length) === length) || (str.indexOf("{", 0) === 0 && str.indexOf("}", length) === length) || (str.indexOf("[", 0) === 0 && str.indexOf("]", length) === length) || (!isNaN(parseInt(str)));
}

/**
 * jQuery plugin to help bridge the gap between Twig and Javascript.
 */
(function($, window, document, undefined) {
    "use strict";

    const pluginName = "twig";
    let instance = undefined;

    /**
     * Plugin constructor.
     *
     * @param {object} options
     *
     * @constructor
     */
    function Plugin(options) {
        this.options = $.extend({}, this._defaults, options);

        return this.init();
    }

    Plugin.prototype = {
        _defaults: {
            /**
             * Whether to bark about adding/overriding vars that already exist.
             * @type {boolean}
             */
            strict: false,
        },
        _vars: {},

        /**
         * The DOM element.
         */
        element: undefined,

        /**
         * Initialize the plugin.
         *
         * @returns {jQuery}
         */
        init: function() {
            if (typeof __twigVars__ !== "undefined") {
                console.debug("Loading %s twig variables into memory: %o", Object.keys(__twigVars__).length, Object.keys(__twigVars__));
                this.add(__twigVars__);
            } else {
                console.warn("Attempting to load the plugin without first calling {{ export }}");
            }

            return this;
        },

        /**
         * Add a new {key} with {value} to the collection. If {key} is an object,
         * then it will be added in bulk.
         *
         * @param {string|object} key The name of the key being added.
         * @param {string|*} value Either a JSON-parsed string, or the final representation of data.
         *
         * @returns {jQuery}
         */
        add: function(key, value = undefined) {
            if (typeof key === "object") {
                for (const k in key) {
                    this.add(k, key[k]);
                }

                return this;
            }

            if (this.options.strict && this.has(key)) {
                throw new Error("[strict] The var " + key + " has already been set.");
            }

            this._vars[key] = isJSON(value) ? JSON.parse(value) : value;

            return this;
        },

        /**
         * Return the value of {key}. If {key} does not exist, return {defValue}.
         * If {key} is not provided (or undefined), then return a copy of the
         * entire collection.
         *
         * @param {string|null|undefined} key The key of the value to be returned.
         * @param {*|undefined} defValue The value to return if the key does not exist.
         *
         * @returns {undefined|*}
         */
        get: function(key, defValue = undefined) {
            if (typeof key !== "string") {
                return $.extend({}, this._vars);
            }

            return this.has(key) ? getByPath(key, this._vars) : defValue;
        },

        /**
         * Return whether or not {key} exists in the collection.
         *
         * @param {string} key The name of the key to test.
         *
         * @returns {boolean}
         */
        has: function(key) {
            return typeof getByPath(key, this._vars) !== "undefined";
        },
    };

    $[pluginName] = function(options) {
        if (typeof instance === "undefined") {
            instance = new Plugin(options).init();

            if (__DEV__ && typeof global.twig === "undefined") {
                global.twig = instance;
            }
        }

        return instance;
    };
})(jQuery, window, document);
